import { ResursTreeApi } from '../../../services/modules/tree';

export const getNeighboorTree = (
  tree: ResursTreeApi.treeName,
  location: string
) => {
  /** */
  switch (location) {
    case 'device': {
      switch (tree) {
        case 'device':
          return 'user';
        case 'user':
          return 'device';
      }
    }
  }
};
